(function () {
  var PE_ARROW_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false" aria-hidden="true"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg>';

  function parseGlassCount(tier, card) {
    if (tier && tier.glassCount > 0) {
      return tier.glassCount;
    }

    var freeEl = card && card.querySelector('.tier-desc .free');
    var source = freeEl ? freeEl.textContent : (tier && tier.includes) || '';
    var match = source.match(/set of\s*(\d+)/i) || source.match(/(\d+)\s*glasses?/i);
    return match ? parseInt(match[1], 10) : 0;
  }

  function buildIncludesLabel(tier, card) {
    var bottles = tier && tier.bottleCount ? tier.bottleCount : 0;
    var glasses = parseGlassCount(tier, card);
    var parts = [];

    if (bottles > 0) {
      parts.push(bottles + (bottles === 1 ? ' bottle' : ' bottles'));
    }

    if (glasses > 0) {
      parts.push(glasses + (glasses === 1 ? ' glass' : ' glasses'));
    }

    return parts.join(', ');
  }

  function syncLineItemProperties(root, tier, card) {
    var propSet = root.querySelector('[data-pe-prop-set]');
    var propIncludes = root.querySelector('[data-pe-prop-includes]');

    if (!propSet && !propIncludes) return;

    if (propSet) propSet.value = (tier && tier.tierName) || '';
    if (propIncludes) propIncludes.value = buildIncludesLabel(tier, card);
  }

  function getSelectedVariantId(root) {
    var checked = root.querySelector('input[data-pe-tier]:checked');
    return checked ? checked.value : '';
  }

  function syncVariantInput(root, variantInput) {
    var id = getSelectedVariantId(root);
    if (variantInput && id) {
      variantInput.value = id;
    }
    return id;
  }

  function destroyGallerySlider(root) {
    if (typeof jQuery === 'undefined' || !jQuery.fn.slick) return;
    jQuery(root)
      .find('[data-pe-gallery-main], [data-pe-gallery-thumbs]')
      .each(function () {
        var $el = jQuery(this);
        if ($el.hasClass('slick-initialized')) {
          $el.find('.slick-list').css({ height: '', width: '' });
          $el.slick('unslick');
        }
      });
  }

  function debounceSetPosition($main, $thumbs) {
    if ($main && $main.hasClass('slick-initialized')) {
      $main.slick('setPosition');
    }
    if ($thumbs && $thumbs.hasClass('slick-initialized')) {
      $thumbs.slick('setPosition');
    }
  }

  function initStaticGallery(root) {
    var main = root.querySelector('[data-pe-gallery-main]');
    var thumbs = root.querySelector('[data-pe-gallery-thumbs]');
    if (!main || !thumbs) return;

    var slides = main.querySelectorAll('.pe-gallery-slide');
    var thumbSlides = thumbs.querySelectorAll('.pe-gallery-thumb-slide');
    if (slides.length < 2) return;

    slides.forEach(function (slide, index) {
      slide.hidden = index !== 0;
    });
    if (thumbSlides[0]) thumbSlides[0].classList.add('is-active');

    thumbSlides.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        slides.forEach(function (slide, i) {
          slide.hidden = i !== index;
        });
        thumbSlides.forEach(function (t, i) {
          t.classList.toggle('is-active', i === index);
        });
      });
    });
  }

  function initGallerySlider(root, attempt) {
    attempt = attempt || 0;
    if (typeof jQuery === 'undefined' || !jQuery.fn.slick) {
      if (attempt < 40) {
        setTimeout(function () {
          initGallerySlider(root, attempt + 1);
        }, 100);
      }
      return;
    }

    var $root = jQuery(root);
    var $main = $root.find('[data-pe-gallery-main]');
    var $thumbs = $root.find('[data-pe-gallery-thumbs]');
    if (!$main.length) return;

    var enableSlider = $main.attr('data-enable-slider') !== 'false';
    var slideCount = $main.children('.pe-gallery-slide').length;
    if (slideCount < 2) return;

    destroyGallerySlider(root);

    if (!enableSlider) {
      initStaticGallery(root);
      return;
    }

    $main.children('.pe-gallery-slide').each(function () {
      this.hidden = false;
    });

    var prevArrow =
      '<button type="button" class="slick-prev pe-gallery-arrow" aria-label="Previous slide">' +
      PE_ARROW_SVG +
      '</button>';
    var nextArrow =
      '<button type="button" class="slick-next pe-gallery-arrow" aria-label="Next slide">' +
      PE_ARROW_SVG +
      '</button>';

    var thumbCount = $thumbs.children('.pe-gallery-thumb-slide').length;
    var hasThumbs = $thumbs.length && thumbCount > 0;

    $main.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: false,
      fade: false,
      adaptiveHeight: false,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      asNavFor: hasThumbs ? $thumbs : undefined,
    });

    if (hasThumbs) {
      $thumbs.slick({
        slidesToShow: Math.min(3, thumbCount),
        slidesToScroll: 1,
        asNavFor: $main,
        dots: false,
        arrows: false,
        focusOnSelect: true,
        infinite: true,
        centerMode: false,
      });
    }

    var resizeKey = 'peGalleryResize-' + (root.dataset.sectionId || 'hero');
    var resizeTimer;
    jQuery(window)
      .off('resize.' + resizeKey)
      .on('resize.' + resizeKey, function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          debounceSetPosition($main, $thumbs);
        }, 150);
      });

    $main.find('img').one('load', function () {
      debounceSetPosition($main, $thumbs);
    });

    setTimeout(function () {
      debounceSetPosition($main, $thumbs);
    }, 100);
  }

  function init(root) {
    if (!root || root.dataset.peInit === 'true') return;
    root.dataset.peInit = 'true';

    initGallerySlider(root);

    var configEl = root.querySelector('[data-pe-config]');
    var config = { tiers: {}, productTitle: '' };
    if (configEl) {
      try {
        config = JSON.parse(configEl.textContent);
      } catch (e) {
        config = { tiers: {}, productTitle: '' };
      }
    }

    var form = root.querySelector('[data-pe-form]');
    var variantInput = root.querySelector('[data-pe-variant-id]');
    var ctaKicker = root.querySelector('[data-pe-cta-kicker]');
    var ctaMain = root.querySelector('[data-pe-cta-main]');
    var giftText = root.querySelector('[data-pe-gift-text]');
    var giftStrip = root.querySelector('[data-pe-gift-strip]');

    function applyTier(tierId) {
      if (!tierId) return;

      syncVariantInput(root, variantInput);

      var tier = config.tiers && config.tiers[tierId];
      if (!tier) {
        tier = { variantId: tierId };
      }

      if (variantInput) variantInput.value = String(tier.variantId || tierId);

      var radio = root.querySelector('input[data-pe-tier][value="' + tierId + '"]');
      var card = radio ? radio.closest('.tier') : null;
      var priceEl = card ? card.querySelector('.price-now') : null;
      var priceText = priceEl ? priceEl.textContent.trim() : '';

      if (ctaKicker && tier.ctaKicker) ctaKicker.textContent = tier.ctaKicker;

      if (ctaMain) {
        var prefix = tier.ctaMainPrefix || tier.ctaMain || 'Add to cart';
        if (priceText) {
          ctaMain.textContent = prefix + ' · ' + priceText;
        } else if (tier.ctaMain) {
          ctaMain.textContent = tier.ctaMain;
        }
      }

      if (giftText) giftText.innerHTML = tier.giftHtml || '';
      if (giftStrip) giftStrip.hidden = !tier.giftHtml;

      syncLineItemProperties(root, tier, card);
    }

    root.querySelectorAll('input[data-pe-tier]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        applyTier(radio.value);
      });
    });

    var checked = root.querySelector('input[data-pe-tier]:checked');
    if (checked) {
      applyTier(checked.value);
    } else {
      syncVariantInput(root, variantInput);
    }

    if (form) {
      form.addEventListener(
        'submit',
        function (e) {
          var id = syncVariantInput(root, variantInput);
          if (!id) {
            e.preventDefault();
            return;
          }

          if (variantInput) variantInput.value = id;

          var checkedRadio = root.querySelector('input[data-pe-tier]:checked');
          var activeTier = config.tiers && config.tiers[id];
          var activeCard = checkedRadio ? checkedRadio.closest('.tier') : null;
          syncLineItemProperties(root, activeTier, activeCard);
        },
        true
      );

      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) {
        submitBtn.addEventListener(
          'click',
          function () {
            syncVariantInput(root, variantInput);
            var id = getSelectedVariantId(root);
            var checkedRadio = root.querySelector('input[data-pe-tier]:checked');
            syncLineItemProperties(
              root,
              config.tiers && config.tiers[id],
              checkedRadio ? checkedRadio.closest('.tier') : null
            );
          },
          true
        );
      }
    }
  }

  function boot() {
    document.querySelectorAll('[data-pe-hero]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-pe-hero]');
    if (root) {
      root.dataset.peInit = '';
      init(root);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-pe-hero]');
    if (root) {
      var resizeKey = 'peGalleryResize-' + (root.dataset.sectionId || 'hero');
      if (typeof jQuery !== 'undefined') {
        jQuery(window).off('resize.' + resizeKey);
      }
      destroyGallerySlider(root);
    }
  });
})();
